export default "__VITE_ASSET__D1VWygU3__"